<template>
  <v-card :disabled="loading" flat class="pa-2">
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="cyan"
    ></v-progress-linear>
    <v-stepper v-if="!loading" flat class="" v-model="e1">
      <v-stepper-items>
        <v-stepper-content class="pa-0" step="1">
          <v-row v-if="items.length > 0">
            <v-col class="" v-for="(key, i) in items" :key="i" cols="12">
              <v-card flat class="border d-flex align-items-center rounded-xl">
                <v-card-text
                  >{{ $t("listFeedbackUser.question_label") }}:
                  {{ key.question }}</v-card-text
                >
                <v-card-actions>
                  <v-btn
                    @click="fetch(key)"
                    :loading="loading"
                    outlined
                    class="ml-2 rounded-xl"
                    color="green"
                  >
                    <v-icon>mdi-eye</v-icon>
                    {{ $t("listFeedbackUser.show_answers") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-card flat v-else class="text-center">
            <v-card-title class="d-flex justify-content-center">
              {{ $t("listFeedbackUser.no_questions") }}
            </v-card-title>
            <v-card-subtitle>
              {{ $t("listFeedbackUser.add_feedback_prompt") }}
            </v-card-subtitle>
          </v-card>
        </v-stepper-content>
        <v-stepper-content class="pa-0" step="2">
          <v-card flat>
            <v-card-actions>
              <v-btn outlined color="red" @click="e1 = 1">
                <v-icon>mdi-chevron-right</v-icon
                >{{ $t("listFeedbackUser.back_button") }}
              </v-btn>
            </v-card-actions>
            <v-card-title>{{ awnsers.question }}</v-card-title>
            <v-row v-if="awnsers.items.length > 0" class="pa-2">
              <v-col
                cols="12"
                md="6"
                xl="4"
                v-for="(key, i) in awnsers.items"
                :key="i"
              >
                <v-card
                  flat
                  class="rounded-xl border pa-2 justify-content-around d-flex text-center align-items-center"
                >
                  <v-card-subtitle class="pa-0">{{
                    persian(i + 1)
                  }}</v-card-subtitle>
                  <p class="ma-0" v-if="key.awnser">
                    {{ $t("listFeedbackUser.user_opinion") }}: {{ key.awnser }}
                  </p>
                  <v-btn height="25px" dense outlined>
                    {{ $t("listFeedbackUser.score_label") }}:
                    {{ persian(key.value) }}
                  </v-btn>
                </v-card>
              </v-col>
            </v-row>
            <v-card v-else flat class="text-center">
              <v-card-subtitle>{{
                $t("listFeedbackUser.no_feedback")
              }}</v-card-subtitle>
            </v-card>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "listFeedbackUser",
  props: {
    info: { type: Object },
    value: { type: Object, required: true },
    data: { type: Object },
    dialogs: { type: [Boolean], default: null },
  },
  data() {
    return {
      loading: false,
      items: [],
      domainInfo: "",
      awnsers: { question: "", items: [] },
      identifierInfo: "",
      loading_items: {},
      qridInfo: "",
      e1: 1,
      types: [
        { id: 1, type: "emoji" },
        { id: 2, type: "text" },
        { id: 3, type: "emoji_slider" },
        { id: 4, type: "star" },
        { id: 5, type: "thumbs" },
        { id: 6, type: "slider" },
      ],
    };
  },
  mounted() {
    this.fetchAllFeedback();
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    info: {
      deep: true,
      immediate: true,
      handler(val) {
        if (this?.info) {
          this.domainInfo = val.domain.name;
          this.identifierInfo = val.identifier;
          this.qridInfo = val.id;
        }
      },
    },
    dialogs(val) {
      if (val) {
        this.fetchAllFeedback();
      } else {
        this.items = [];
      }
    },
    items: {
      deep: true,
      handler(val) {
        console.log(val);
      },
    },
  },
  computed: {
    ...mapState("localstorage", ["createQrID"]),
    ...mapState("local", ["identifier", "domain", "qr_id"]),
    ...mapGetters("ribbon", ["user"]),
  },
  methods: {
    fetch(e) {
      this.loading = true;
      this.awnsers.question = e.question;
      this.e1 = 2;
      this.$api
        .get(`v1/testQr/feedback/feedBackAnswers`, {
          params: { question_id: e.id },
        })
        .then(({ data }) => {
          console.log(data.data);
          this.awnsers.items = data.data.map((item) => ({
            awnser: item.answer,
            value: item.rate,
            type_id: item.type_id,
          }));
        })
        .finally(() => (this.loading = false));
    },
    fetchAllFeedback() {
      this.loading = true;
      let domain = this?.info
        ? this.domainInfo
        : this.domainName ?? this.domain === 5
        ? "qrland.in/"
        : "";
      let identifier = this?.info
        ? this.identifierInfo
        : this.qrId ?? this.identifier;
      this.$api
        .get(`/v1/testQr/feedback/${domain}${identifier}`)
        .then(({ data }) => {
          this.items = data.data.map((item) => ({
            id: item.id,
            question: item.question,
            type: this.types.find((type) => type.id == item.type_id).type,
            answer: item.answer,
            description: item.has_description,
            forceDesc: item.description_status === "required",
          }));
        })
        .catch(({ response }) => {})
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style></style>
